import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const SERVICE_REQUEST = 'sherrinford/service/list/SERVICE_REQUEST'
export const SERVICE_SUCCESS = 'sherrinford/service/list/SERVICE_SUCCESS'
export const SERVICE_ERROR = 'sherrinford/service/list/SERVICE_ERROR'

export const IS_LOADING = 'sherrinford/service/list/IS_LOADING'
export const DATA = 'sherrinford/service/list/DATA'

export const SET_INPUT_DATA_SERVICE = 'sherrinford/service/list/SET_INPUT_DATA_SERVICE'

export const SET_IS_EDIT_CATEGORY = 'sherrinford/service/list/SET_IS_EDIT_CATEGORY'

export const SET_CURRENT_DATA = 'sherrinford/service/list/SET_CURRENT_DATA'

export const SET_SELECTED_ID_CATEGORY = 'sherrinford/service/list/SET_SELECTED_ID_CATEGORY'

export const RESET_INPUT_DATA_SERVICE = 'sherrinford/service/list/RESET_INPUT_DATA_SERVICE'

export const SET_FILE_LOGO_CATEGORY = 'sherrinford/services/list/SET_FILE_LOGO_CATEGORY'

export const SET_ERROR_LOGO_INPUT_TEXT = 'sherrinford/services/list/SET_ERROR_LOGO_INPUT_TEXT'

export const RESET_IMAGE_LOGO = 'sherrinford/services/list/RESET_IMAGE_LOGO'

export const SET_OPEN_MODAL_PREVIEW_LOGO = 'sherrinford/services/list/SET_OPEN_MODAL_PREVIEW_LOGO'

const initialState = {
  data: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
  inputDataService: {
    productType: '',
    name: '',
    serviceTitle: '',
    serviceDesc: '',
    logo: '',
    isUsable: true,
    isSearchable: false,
  },
  categoryFileLogo: {},
  isEditCategory: false,
  selectedIdCategory: '',
  errorLogoInputText: '',
  isOpenModalPreviewLogo: false,
}

export default createReducer(initialState, {
  [SERVICE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [SERVICE_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [SERVICE_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),

  [SET_INPUT_DATA_SERVICE]: (state, data) => ({
    ...state,
    inputDataService: {
      ...state.inputDataService,
      [data.field]: data.value,
    },
  }),

  [SET_IS_EDIT_CATEGORY]: (state, data) => ({
    ...state,
    isEditCategory: data,
  }),

  [SET_CURRENT_DATA]: (state, data) => ({
    ...state,
    inputDataService: data,
  }),

  [SET_SELECTED_ID_CATEGORY]: (state, data) => ({
    ...state,
    selectedIdCategory: data,
  }),

  [RESET_INPUT_DATA_SERVICE]: state => ({
    ...state,
    inputDataService: initialState.inputDataService,
    categoryFileLogo: initialState.categoryFileLogo,
    errorLogoInputText: initialState.errorLogoInputText,
  }),

  [SET_FILE_LOGO_CATEGORY]: (state, data) => ({
    ...state,
    categoryFileLogo: data,
  }),

  [SET_ERROR_LOGO_INPUT_TEXT]: (state, data) => ({
    ...state,
    errorLogoInputText: data,
  }),

  [RESET_IMAGE_LOGO]: state => ({
    ...state,
    categoryFileLogo: initialState.categoryFileLogo,
    inputDataService: {
      ...state.inputDataService,
      logo: initialState.inputDataService.logo,
    },
  }),

  [SET_OPEN_MODAL_PREVIEW_LOGO]: (state, data) => ({
    ...state,
    isOpenModalPreviewLogo: data,
  }),
})

export const getServices = (qs) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      SERVICE_REQUEST,
      SERVICE_SUCCESS,
      SERVICE_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/service',
      authorization: `${token}`,
      payloads: qs,
    },
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const setInputDataService = data => ({
  type: [SET_INPUT_DATA_SERVICE],
  payload: data,
})

export const setIsEditCategory = data => ({
  type: [SET_IS_EDIT_CATEGORY],
  payload: data,
})

export const setCurrentData = data => ({
  type: [SET_CURRENT_DATA],
  payload: data,
})

export const setSelectedIdCategory = data => ({
  type: [SET_SELECTED_ID_CATEGORY],
  payload: data,
})

export const resetInputDataService = () => ({
  type: [RESET_INPUT_DATA_SERVICE],
})

export const setFileLogoCategory = data => ({
  type: [SET_FILE_LOGO_CATEGORY],
  payload: data,
})

export const setErrorLogoInputText = data => ({
  type: [SET_ERROR_LOGO_INPUT_TEXT],
  payload: data,
})

export const resetImageLogo = () => ({
  type: [RESET_IMAGE_LOGO],
})

export const setOpenModalPreviewLogo = data => ({
  type: [SET_OPEN_MODAL_PREVIEW_LOGO],
  payload: data,
})
